import React from "react";
import PolicyLayout from "./PolicyLayout";

function ComplaintsPolicy() {
  return (
    <PolicyLayout
      title="Complaints, disputes and policy updates"
      intro="This procedure brings together unresolved shopping, payment, delivery, product, privacy and accessibility concerns without limiting mandatory rights."
    >
      <section>
        <h2>Submit a focused complaint</h2>
        <p>Use the published support email and state the affected page or order number, the relevant dates, what happened, supporting photographs or correspondence, and the outcome requested. Redact full card numbers, security codes and unrelated personal information. Urgent product-safety concerns should be identified in the subject and the product should not be used.</p>
      </section>

      <section>
        <h2>Review method</h2>
        <p>The complaint is matched to available storefront, payment-session, correspondence and delivery evidence. Where another person or service holds necessary information, only the portion relevant to the issue should be sought. The response will explain the established facts, applicable policy, decision and next action.</p>
      </section>

      <section>
        <h2>Escalation and legal rights</h2>
        <p>A customer who disagrees with the initial decision can identify the conclusion challenged and add relevant evidence for a fresh review. Using this internal channel does not require anyone to surrender access to a competent public body, a card issuer process, a court, or another remedy that cannot lawfully be excluded. These policies do not choose an exclusive regulator, governing law or court.</p>
      </section>

      <section>
        <h2>Policy updates</h2>
        <p>The date shown above marks this edition. New wording ordinarily governs future browsing and later orders, except where a mandatory rule requires another outcome. Before publishing a material operating-region change, the contact information, delivery, returns, privacy, currency presentation, customs, tax wording, address formats, SEO and connected customer messages must be reviewed together.</p>
      </section>

      <section>
        <h2>Conflicts between pages</h2>
        <p>The product page controls item-specific dimensions, materials and care; the checkout controls the selected lines and displayed amount; these policies control their named processes. A clearly stated product restriction prevails over a general care example, but it cannot remove a mandatory consumer or safety right.</p>
      </section>
    </PolicyLayout>
  );
}

export default ComplaintsPolicy;
